/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Notfound_BackInputs */

const en_common_notfound_back = /** @type {(inputs: Common_Notfound_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to home`)
};

const zh_common_notfound_back = /** @type {(inputs: Common_Notfound_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回首页`)
};

/**
* | output |
* | --- |
* | "Back to home" |
*
* @param {Common_Notfound_BackInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_notfound_back = /** @type {((inputs?: Common_Notfound_BackInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Notfound_BackInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_notfound_back(inputs)
	return zh_common_notfound_back(inputs)
});
export { common_notfound_back as "common.notfound.back" }